






import L from "leaflet";
import { findRealParent } from "vue2-leaflet";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class TileLayerGoogleMutant extends Vue {
  @Prop() options!: L.gridLayer.GoogleMutantOptions;

  ready = false;
  mapObject?: L.GridLayer;
  parentContainer?: L.Map;

  async mounted() {
    await import("leaflet.gridlayer.googlemutant");

    this.parentContainer = findRealParent(this.$parent);
    this.updateMapObject();
  }

  beforeDestroy() {
    if (this.parentContainer) {
      this.parentContainer.removeLayer(this as any);
    }
  }

  @Watch("options")
  updateMapObject(options?: any, prevOptions?: any) {
    if (!options || JSON.stringify(options) !== JSON.stringify(prevOptions)) {
      if (this.mapObject) {
        this.parentContainer!.removeLayer(this as any);
      }

      this.mapObject = L.gridLayer.googleMutant(this.options);
      this.parentContainer!.addLayer(this as any);
    }
  }
}
